<div class="wrapper">
  <div class="header">
    <div class="logo">
      <img src="{{ officeLogo }}" *ngIf="officeLogo!=''" width="" />
      <!-- <img src="./../../../assets/images/chatGPT.png" alt="" > -->
    </div>
    <div class="links">
      <ul>        
        <li *ngIf="personID!=0"><a (click)="showMenu('dashboard')" [ngClass]="{'active': currentNavigation == 'dashboard'}">Dashboard</a></li>
        <li *ngIf="personID!=0"><a (click)="showMenu('detail')" [ngClass]="{'active': currentNavigation == 'detail'}">Detail</a></li>
      </ul>
    </div>
    <div class="office">
      <button mat-icon-button (click)="showMenu('home')" [ngClass]="{'active': currentNavigation == 'home'}"><mat-icon>home</mat-icon></button>
      <ng-select [searchable]="true" [clearAllText]="false" placeholder="Select" class="status_dropdown"
        (change)="selectPeoples($event)" [(ngModel)]="selectedPersonId">

        <ng-option *ngFor="let item of coreDropdownList" [value]="item.personID">
          <div class="statusOptions">
            <div class="nameOffice"><span class="name">{{item.name}}</span> <span
                class="officeName">{{item.email}}</span></div>
            <div class="email">{{item.officeName}}</div>
          </div>
        </ng-option>

      </ng-select>

      <button *ngIf="broadCastList.length==0" class="chat" mat-icon-button
        [matMenuTriggerFor]="menu"><mat-icon>notifications</mat-icon></button>

      <button *ngIf="broadCastList.length>0" class="chat" [matMenuTriggerFor]="menu" matBadge="{{broadCastList.length}}"
        matBadgePosition="after" matBadgeColor="accent" mat-icon-button><mat-icon>notifications</mat-icon></button>
      <mat-menu #menu="matMenu" class="customPanel">
        <button mat-menu-item *ngFor="let data of broadCastList">
          <mat-icon (click)="showBroadcastDetails(data,showBroadcastDialog)">library_books</mat-icon>
          <span (click)="showBroadcastDetails(data,showBroadcastDialog)">{{data.title}}</span>
          <!--span (click)="showBroadcastDetails(data,showBroadcastDialog)">{{data.officeName}}, {{data.organizationName}}</span> -->
        </button>
        <button class="showMore" mat-menu-item color="primary" (click)="showMenu('broadcastMessage')">
          <span>Show more</span>
        </button>
      </mat-menu>

      <!-- <button class="chat" mat-icon-button><mat-icon>chat</mat-icon></button> -->
      <div  class="toolbar-separator "></div>

      <button mat-icon-button (click)="showChats()" class="chat-panel-toggle-button "
        aria-label="Toggle chat panel">
        <mat-icon matBadgeColor="warn" class="secondary-text">chat</mat-icon>
      </button>

      <button class="chat" mat-icon-button matTooltip="Logout"
        (click)="logout()"><mat-icon>power_settings_new</mat-icon></button>

      <img src="./../../../assets/images/logo/MiniLogo.png" />

    </div>
  </div>
  <div class="allContainer" [ngStyle]="{background: 'url(' + backgroundImage + ') no-repeat'}">
    <div class="welcomeBlock">
      <div class="welcome">
        <h2>Hi {{portalName}}</h2>
        <!-- <span>Monday June 6</span> -->
        <span>{{myDate | date:'EEEE, MMMM d'}}</span>
      </div>

      <div class="latestNote" *ngIf="TopbroadCast" (click)="showBroadcastDetails(TopbroadCastList,showBroadcastDialog)">
        <p>
          {{TopbroadCast}}
        </p>
        <!-- <p>Most recent note will appear here..........</p> -->
      </div>

    </div>

    <div class="">
      <div class="shorthands">

        <div class="signature" (click)="OpenSignPopup(AddSignature)">
          <label>powered by flowtrics!</label>
          <!-- <div class="signatureThumb">  -->
          <!-- <img src="../../../assets/images/signature.png" alt=""> -->
          <!-- </div> -->

          <div class="signatureThumb">

            <ng-container *ngIf="signatureBase64!='' || signName || signOrInitialImageObj.length>0; else noSignature">
              <img width="" height="50" *ngIf="signatureBase64!=''" [src]="signatureBase64" />
              <ng-container *ngIf="signName">
                <h3 [ngStyle]="{'font-family': signInitialFontFamily,'height': '60px'}">{{signName}}
                </h3>
              </ng-container>

              <img width="" height="50" *ngIf="signOrInitialImageObj.length>0"
                [src]="signOrInitialImageObj[0].Imageurl" />
            </ng-container>

            <ng-template #noSignature>
              <div class="noSignature">
                <mat-icon>add</mat-icon> Add Signature
              </div>
            </ng-template>

            <!-- <div *ngFor="let img of field.ImageData" class="uploadedData"
                      [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                      <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                    </div> -->

          </div>

        </div>
        <div class="sorts">
          <div class="short" *ngIf="personID>0" matTooltip="Add Activity" matTooltipClass="tooltip"
            (click)="addTouch()">
            <button mat-icon-button><mat-icon>post_add</mat-icon></button>
          </div>

          <div class="short" *ngIf="isHome!=true" matTooltip="Add Note" matTooltipClass="tooltip" (click)="addNotes('new',addNotesDialog)">
            <button mat-icon-button><mat-icon>note_add</mat-icon></button>
          </div>

          <div class="short" *ngIf="personID>0" matTooltip="Add Document" matTooltipClass="tooltip">
            <!-- <button mat-icon-button><mat-icon>assignment_add</mat-icon></button> -->
            <input #Input hidden="true" type="file" multiple (change)="selectFilesFromDragZone($event)">
            <button mat-icon-button (click)="Input.click()">
              <mat-icon>assignment_add</mat-icon>
            </button>

          </div>

        </div>

      </div>
    </div>

    <ng-container *ngIf="isDashboard">
      <div class="contentWrapper">

       
        <div class="wrapperBlock">

          <div class="onefourth withButton">

            <div class="block" [ngClass]="{'active': isDashboard && currentNavigation !='home' }" >

              <div class="head">
                <div class="label">
                  <h2>Waiting Actions</h2><span>{{totalWaitingActions}}</span>
                </div>
                <div class="act">
                  <!-- <button mat-icon-button ><mat-icon>add</mat-icon></button> -->
                </div>
              </div>
  
              <div class="content">
                <div class="line" *ngFor="let data of waitingActions">
                  <div class="icon">
                    <mat-icon>{{getIcon(data.aType)}}</mat-icon>
                  </div>
                  <div class="text_act">
                    <div class="text">
                      <p> {{data.title}}</p>
  
                      <div class="ofndate">
                        <!-- <div class="ofname">Organization name > Office name</div> -->
                        <div class="ofname">{{data.organizationName}} > {{data.officeName}}</div>
                        <span>{{data.createdOn+'Z' | date:'MM/dd/yyyy'}} </span>
                      </div>
                    </div>
                    <div class="actInfo">
  
                      <button mat-stroked-button color="primary" (click)="openLink(data)">Open</button>
                    </div>
                  </div>
                </div>
                <!-- <div>
                              <button *ngIf="AllwaitingActions.length>10" (click)="showActivity()">Show More</button>
                            </div> -->
                <div class="noAction" *ngIf="waitingActions.length == 0">
                  <!-- <p>No more waiting. Everything's done! <br> Celebrate the joy. 🎉 </p> -->
                  <p>No Pending Actions.</p>
                </div>
              </div>
  
            </div>
  

            <ng-container *ngIf="currentNavigation=='home'">
              <div class="block ">
      
                <div class="head">
                  <div class="label">
                    <h2>Forms</h2><span>{{totalPortalFormsforHome}}</span>
                  </div>
                  <div class="act">
                    <!-- <button mat-icon-button ><mat-icon>add</mat-icon></button> -->
                  </div>
                </div>
      
                <div class="content">
                  <div class="line" *ngFor="let data of PortalFormsforHome">
                    <div class="icon">
                      <mat-icon>{{getIcon(data.aType)}}</mat-icon>
                    </div>
                    <div class="text_act">
                      <div class="text">
                        <p> {{data.title}}</p>
      
                        <div class="ofndate">
                          <!-- <div class="ofname">Organization name > Office name</div> -->
                          <div class="ofname">{{data.organizationName}} > {{data.officeName}}</div>
                          <span>{{data.createdOn+'Z' | date:'MM/dd/yyyy'}} </span>
                        </div>
                      </div>
                      <div class="actInfo">
      
                        <button mat-stroked-button color="primary" (click)="openLink(data)">Open</button>
                      </div>
                    </div>
                  </div>
                  <!-- <div>
                                <button *ngIf="AllwaitingActions.length>10" (click)="showActivity()">Show More</button>
                              </div> -->
                  <div class="noAction" *ngIf="PortalFormsforHome.length == 0">
                    <p>Currently, there are no forms shared.</p>
                  </div>
                </div>
      
              </div>         
              </ng-container>
          </div>

   



          <div class="block half">
            <div class="head">
              <div class="label">
                <h2>Notes</h2><span>{{totalNotes}}</span>
              </div>
              <div class="act">
                <button *ngIf="isHome!=true" mat-icon-button (click)="addNotes('new', addNotesDialog)">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
            <div class="content notesContent"  [style.max-height]="isDashboard && currentNavigation !='home' ? '40vh' : '66vh' " >

              <ng-container *ngFor="let data of notesList">
                <div class="line" [ngStyle]="{'background-color': data.color }">

                  <!-- <div class="noterow"  [ngStyle]="{'background-color': data.color }"> -->
                  <div class="icon"><mat-icon>speaker_notes</mat-icon></div>

                  <div class="text_act col">
                    <div class="text">
                      {{data.note}}
                    </div>
                    <div class="actInfo">
                      <span>{{data.updatedOn+'Z' | date:'MM/dd/yyyy'}} </span>
                      
                      <div class="edit_act" *ngIf="isHome!=true">
                        <span class="edit" (click)="removeNote(data)"><mat-icon>delete</mat-icon></span>
                        
                        <span class="edit" (click)="addNotes(data, addNotesDialog)"  ><mat-icon>edit</mat-icon></span>

                      </div>

                    </div>
                  </div>
                  <!-- </div> -->

                </div>
              </ng-container>


              <div class="noAction" *ngIf="notesList.length == 0">
                <p>Let's start with your first note.</p>
              </div>
              <!-- <div class="line">
                              
                              <div class="icon"><mat-icon>speaker_notes</mat-icon></div>

                              <div class="text_act col">
                                  <div class="text">
                                      "Your life is about to be incredible," Your life is
                                      about to be incredible,"
                                  </div>
                                  <div class="actInfo">
                                      <span>11/21/20</span>
                                      <div class="edit_act">
                                          
                                          <span class="edit" ><mat-icon>delete</mat-icon></span>
                                          <span class="edit" ><mat-icon>edit</mat-icon></span>
                                  </div>
                                  </div>
                              </div>
                              
                          </div>
                          <div class="line">
                              
                              <div class="icon"><mat-icon>speaker_notes</mat-icon></div>

                              <div class="text_act col">
                                  <div class="text">
                                      "Your life is about to be incredible," Your life is
                                      about to be incredible,"
                                  </div>
                                  <div class="actInfo">
                                      <span>11/21/20</span>
                                      <div class="edit_act">
                                          
                                          <span class="edit" ><mat-icon>delete</mat-icon></span>
                                          <span class="edit" ><mat-icon>edit</mat-icon></span>
                                  </div>
                                  </div>
                              </div>
                              
                          </div> -->
            </div>
          </div>
          <!-- *ngIf="personID!=0" -->
          <div class="block three" *ngIf="isHome==true">
            <div class="head">
              <div class="label">
                <h2>Activity</h2><span>{{totalActivities}}</span>
              </div>
              <div class="act">
                <button mat-icon-button (click)="addTouch()"><mat-icon>add</mat-icon></button>
              </div>
            </div>
            <div class="content">
              <div class="line" *ngFor="let data of activities">            

                <div class="icon">
                  <mat-icon *ngIf="data.activityTypeName=='Note'">event_note</mat-icon>
                  <mat-icon *ngIf="data.activityTypeName=='Phone Call'">local_phone</mat-icon>
                  <mat-icon *ngIf="data.activityTypeName=='Email'">mail</mat-icon>
                  <mat-icon *ngIf="data.activityTypeName=='Meeting'">recent_actors</mat-icon>
                  <mat-icon *ngIf="data.activityTypeName=='Other'">add_to_photos</mat-icon>
                  <mat-icon *ngIf="data.activityTypeName=='Log'">text_snippet</mat-icon>
                  <mat-icon *ngIf="data.activityTypeName != 'Note' && data.activityTypeName != 'Phone Call' && data.activityTypeName != 'Email' && data.activityTypeName != 'Meeting'
                    && data.activityTypeName != 'Other' && data.activityTypeName != 'Log'">touch_app</mat-icon>
                </div>

                <div class="text_act col">

                  <div class="actInfo">
                    {{data.createdByFirstName |titlecase}} {{data.createdByLastName |titlecase}} added this {{data.activityTypeName}} and {{data.activityStatusName}}
                  </div>
                  
                  <div class="text">
                    {{data.activityNote}}
                  </div>
                 


                  <div class="stHolder">
                    <div class="actInfo">
                      <span *ngIf="data.startDate != null && data.startDate != '0001-01-01T00:00:00'
                       && data.endDate != null && data.endDate != '0001-01-01T00:00:00' ">                    
                        <b>Date:</b>{{data.startDate+'Z' | date:'MM/dd/yyyy'}} - {{data.endDate+'Z' | date:'MM/dd/yyyy'}} 
                        <!-- <p>  {{data.startDate+'Z' | date:'MM/dd/yyyy'}}
                          <span *ngIf="data.startTime != null"> {{data.startTime | date:'h:mm a'}} </span>  
                        </p> -->
                        
                      </span>            
                     
                    </div>
                    <!-- <div class="actInfo">
                      <span *ngIf="data.startDate == null || data.startDate == '0001-01-01T00:00:00'">       
                        <b *ngIf="data.endDate != null && data.endDate != '0001-01-01T00:00:00'">Touch Date:</b>              
                        <p *ngIf="data.endDate != null && data.endDate != '0001-01-01T00:00:00'">  {{data.endDate+'Z' | date:'MM/dd/yyyy'}} </p>
                      </span>
  
                      <span *ngIf="data.startDate != null && data.startDate != '0001-01-01T00:00:00'">        
                        <b>End Date:</b>                 
                        <p *ngIf="data.endDate != null && data.endDate != '0001-01-01T00:00:00'"> 
                           {{data.endDate+'Z' | date:'MM/dd/yyyy'}} 
                           <span *ngIf="data.endTime != null"> {{data.endTime | date:'h:mm a'}} </span>
                          </p>
                       
                      </span>                   
  
                     
                    </div> -->
                    <div class="actInfo" *ngIf="data.startDate != null && data.startDate != '0001-01-01T00:00:00'
                      && data.endDate != null && data.endDate != '0001-01-01T00:00:00' ">
                      <span>
                        <b>Time Taken in day:</b> 
                        <p>
                          
                          {{getTimeSpent(data)}}
                        </p>                      
                      </span>
                    </div>
                  </div>

                  <div class="actInfo">
                    Date: {{data.createdon+'Z' | date:'MM/dd/yyyy'}}
                  </div>



                </div>
              </div>

              <div class="noAction" *ngIf="activities.length == 0">
                <p>No Activity.</p>
              </div>

            </div>
          </div>
 
          <div class="block three withButton" *ngIf="isHome==true">
            <div class="head">
              <div class="label">
                <h2>Forms</h2><span>{{totalForms}}</span>
              </div>
              <div class="act">
                <!-- <button mat-icon-button ><mat-icon>add</mat-icon></button> -->
              </div>
            </div>
            <div class="content">
              <div class="line" *ngFor="let data of forms">
                <div class="icon">
                  <mat-icon>border_color</mat-icon>
                </div>
                <div class="text_act">
                  <div class="text">
                    <!-- <p> OnBoarding Process</p> -->
                    <p> {{data.title}}</p>
                    <!-- <span>11/21/20</span> -->
                     By: {{data.createdByFirstName |titlecase}} {{data.createdByLastName |titlecase}}
                    <br>
                    <span>{{data.createdOn+'Z' | date:'MM/dd/yyyy'}} </span> 
                  </div>
                  <div class="actInfo">

                    <div class="">
                      <button mat-stroked-button color="primary" (click)="openForm(data)">
                        Start
                      </button>
                    </div>
                  </div>
                </div>

              </div>
              <div class="noAction" *ngIf="forms.length == 0">
                <p>No Shared Forms. </p>
              </div>
            </div>
          </div>

          <div class="block three" *ngIf="isHome==true">
            <div class="head">
              <div class="label">
                <h2>Contacts</h2><span>{{totalContacts}}</span>
              </div>
              <div class="act">
                <!-- <button mat-icon-button ><mat-icon>add</mat-icon></button> -->
              </div>
            </div>
            <div class="content">
              <div class="line" *ngFor="let data of contacts">
                <div class="icon">
                  <mat-icon>contacts</mat-icon>
                </div>
                <div class="text_act col">
                  <div class="text">
                    {{data.name}}
                    <!-- Mattmcalpin -->
                  </div>
                  <div class="actInfo">
                    <span>{{data.email}}</span>
                    <span>{{data.phone}}</span>

                    <!-- <span>mattmcalpin@gmail.com</span>
                                      <span>98745-68590</span> -->
                  </div>
                </div>
              </div>
              <div class="noAction" *ngIf="contacts.length == 0">
                <p>No Shared Contacts.</p>
              </div>

            </div>
          </div>
        </div>
      </div>   
    </ng-container>






    <ng-container *ngIf="detail">
      <div class="coreDetail">
        <mat-tab-group>
          <mat-tab label="Documents">
            <div class="block withButton underTask">
              <div class="documentcontainer">
                <div class="categories">
                  <ul>
                    <li *ngFor="let data of coreDetailDocumentList">
                      <div (click)="openDocumentViewer(data,docViewer)">

                    
                      <span class="type" *ngIf="data.fileType == 'pdf' || data.fileType == '.pdf'">                     
                        <app-doc-icons [iconType]="'PDF'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'doc' || data.fileType == 'docx'">
                        <app-doc-icons [iconType]="'WORD'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'xlsx' || data.fileType == 'xls'
                      || data.fileType == 'csv' || data.fileType == 'ods' ">
                        <app-doc-icons [iconType]="'EXCEL'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'jpg' || data.fileType == 'jpeg'
                      || data.fileType == 'image/jpeg' ">
                        <app-doc-icons [iconType]="'JPG'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'png' || data.fileType == 'tiff'
                      || data.fileType == 'webp' ">
                        <app-doc-icons [iconType]="'PNG'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'gif'">
                        <app-doc-icons [iconType]="'GIF'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'bmp'">
                        <app-doc-icons [iconType]="'BMP'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'txt'">
                        <app-doc-icons [iconType]="'TEXT'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'ppt' || data.fileType == 'pptx'">
                        <app-doc-icons [iconType]="'PPT'"></app-doc-icons>
                      </span>

                      <span class="type" *ngIf="data.fileType == 'HEIC' || data.fileType == 'heic'">
                        <app-doc-icons [iconType]="'HEIC'"></app-doc-icons>
                      </span><br>

                      <div class="docname" >{{data.placeholderName}}</div>
                    </div>
                      <div class="actions">
                        <button mat-icon-button color="basic" matTooltip="Download" matTooltipClass="tooltip"
                          (click)="DownloadFile(data)">
                          <mat-icon>cloud_download</mat-icon>
                        </button>

                         <input #Input hidden="true" type="file" (change)="replaceSelectedFiles($event,data)">
                          <button *ngIf="data.placeholderID>0" mat-icon-button (click)="Input.click()"  color="basic" matTooltip="Upload" matTooltipClass="tooltip">            
                            <mat-icon>cloud_upload</mat-icon>
                          </button>                       
                      </div>
                    </li>
                  
                  </ul>
                </div>
                <div class="noAction" *ngIf="coreDetailDocumentList.length == 0">
                  <p>No Documents.</p>
                </div>
              </div>
            </div>


          </mat-tab>

          <mat-tab label="Activity">

            <div class="touches_holder block withButton underTask">

              <div class="touches" *ngFor="let data of coreDetailActivityList">
                <h4 class="note">
                  <div class="icon">
                    <mat-icon *ngIf="data.activityTypeName=='Note'">event_note</mat-icon>
                    <mat-icon *ngIf="data.activityTypeName=='Phone Call'">local_phone</mat-icon>
                    <mat-icon *ngIf="data.activityTypeName=='Email'">mail</mat-icon>
                    <mat-icon *ngIf="data.activityTypeName=='Meeting'">recent_actors</mat-icon>
                    <mat-icon *ngIf="data.activityTypeName=='Other'">add_to_photos</mat-icon>
                    <mat-icon *ngIf="data.activityTypeName=='Log'">text_snippet</mat-icon>
                    <mat-icon *ngIf="data.activityTypeName != 'Note' && data.activityTypeName != 'Phone Call' && data.activityTypeName != 'Email' && data.activityTypeName != 'Meeting'
                    && data.activityTypeName != 'Other' && data.activityTypeName != 'Log'">touch_app</mat-icon>
                  </div>
                  {{data.createdByFirstName |titlecase}} {{data.createdByLastName |titlecase}} added this {{data.activityTypeName}} and {{data.activityStatusName}}
                </h4>
                <p> {{data.activityNote}}</p>
                <p *ngIf="data.createdon != null && data.createdon != '0001-01-01T00:00:00'"> {{data.createdon+'Z' | date:'MM/dd/yyyy'}}</p>


                <div class="stHolder">

                <div class="actInfo" *ngIf="data.startDate != null && data.startDate != '0001-01-01T00:00:00'">
                  <b>Start Date:</b> 
                  <p > 
                    
                    {{data.startDate+'Z' | date:'MM/dd/yyyy'}}
                    <span *ngIf="data.startTime != null"> {{data.startTime | date:'h:mm a'}} </span>
                   </p>
                </div>


                 <div class="actInfo">
                  <span *ngIf="data.startDate == null || data.startDate == '0001-01-01T00:00:00'">       
                    <b *ngIf="data.endDate != null && data.endDate != '0001-01-01T00:00:00'">Touch Date:</b>              
                    <p *ngIf="data.endDate != null && data.endDate != '0001-01-01T00:00:00'">  
                      {{data.endDate+'Z' | date:'MM/dd/yyyy'}} 
                    </p>
                  </span>
                 </div>


                <div class="actInfo">

                  <span *ngIf="data.startDate != null && data.startDate != '0001-01-01T00:00:00'">      
                    <b>End Date:</b>                   
                    <p *ngIf="data.endDate != null && data.endDate != '0001-01-01T00:00:00'"> 
                       {{data.endDate+'Z' | date:'MM/dd/yyyy'}} 
                       <span *ngIf="data.endTime != null"> {{data.endTime | date:'h:mm a'}} </span>
                    </p>
                  </span>  
                </div>

                <div class="actInfo" *ngIf="data.startDate != null && data.startDate != '0001-01-01T00:00:00'
                      && data.endDate != null && data.endDate != '0001-01-01T00:00:00' ">
                  <span>
                    <b>Time Taken in day:</b> 
                    <p>{{getTimeSpent(data)}}</p>                      
                  </span>
                </div>

                </div>

              </div>
              <div class="noAction" *ngIf="coreDetailActivityList.length == 0">
                <p>No Activity.</p>
              </div>             
            </div>

          </mat-tab>


          <mat-tab label="Actions">

            <div class="block withButton underTask">
              <div class="content">

                <div class="line" *ngFor="let data of coreDetailWaitingActionsList">
                  <div class="icon">
                    <mat-icon>task</mat-icon>
                  </div>
                  <div class="text_act">
                    <div class="text">
                      <p> {{data.title}}</p>

                      <div class="ofndate">
                        <div class="ofname">{{data.organizationName}} > {{data.officeName}}</div>
                        <!-- <div class="ofname">Organization name > Office name</div> -->
                        <span>{{data.createdOn+'Z' | date:'MM/dd/yyyy'}} </span>
                      </div>
                    </div>
                    <div class="actInfo">

                      <button mat-stroked-button color="primary" (click)="openLink(data)">Open</button>
                    </div>
                  </div>
                </div>
                <div class="noAction" *ngIf="coreDetailWaitingActionsList.length == 0">
                  <p>No Actions.</p>
                </div>
              </div>

            </div>

          </mat-tab>


        </mat-tab-group>
      </div>
    </ng-container>

    <ng-container *ngIf="broadcastMessage">


      <div class="coreDetail broadcastContainer">
        <div class="content">

          <h3>Broadcast Messages</h3>

          <div class="broadHolder" *ngFor="let data of allBroadCastList">
            <div class="broadImg" (click)="showBroadcastDetails(data,showBroadcastDialog)">
              <img src="{{data.officeLogo}}" width="50" alt="" (click)="showBroadcastDetails(data,showBroadcastDialog)">
            </div>


            <div class="text" (click)="showBroadcastDetails(data,showBroadcastDialog)">
              <h4>{{data.title}} <i>{{data.createdOn+'Z' | date:'MM/dd/yyyy'}} </i></h4>
              <div class="innerHTML" [innerHTML]="data.desc" ></div>
              <div class="nDetail">
                {{data.organizationName}}
                <mat-icon>chevron_right</mat-icon>
                {{data.officeName}}
              </div>

            </div>


          </div>








          <!-- <div class="line" *ngFor="let data of allBroadCastList">
           
            <div class="text" (click)="showBroadcastDetails(data,showBroadcastDialog)">
              <b>{{data.title}}</b>
              <p>{{data.desc}}</p>
              <div class="nDetail">
                {{data.organizationName}}
                <mat-icon>chevron_right</mat-icon>
                {{data.officeName}}
              </div>
                <i>{{data.createdOn+'Z' | date:'MM/dd/yyyy'}} </i>
            </div>

          </div> -->

          <div class="noAction" *ngIf="allBroadCastList.length == 0">
            <p>No Broadcast Messages.</p>
          </div>

          <!-- <div class="line">
            <div class="text">
              <p> "Your life is about to be incredible," Your life is
                about to be incredible,"</p>

              <span>11/21/20</span>
            </div>

          </div>
          <div class="line">
            <div class="text">
              <p> "Your life is about to be incredible," Your life is
                about to be incredible,"</p>

              <span>11/21/20</span>
            </div>

          </div>
          <div class="line">
            <div class="text">
              <p> "Your life is about to be incredible," Your life is
                about to be incredible,"</p>

              <span>11/21/20</span>
            </div>

          </div>
          <div class="line">
            <div class="text">
              <p> "Your life is about to be incredible," Your life is
                about to be incredible,"</p>

              <span>11/21/20</span>
            </div>

          </div> -->
        </div>
      </div>
    </ng-container>

    <div class="footer">
      <img src="./../../../assets/images/logo/flowtrics_logo.png" alt="">
    </div>
  </div>

</div>


<div class="progress-loader" *ngIf="spinner">

  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>


<ng-template #addNotesDialog>
  <h2 mat-dialog-title>
    <span class="groupIconNote"><mat-icon>speaker_notes</mat-icon></span>
    Add Note
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <form [formGroup]="addNotesForm">
      <!-- <mat-radio-group aria-label="" class="selectNote">
          <mat-radio-button color="primary" value="2" [checked]="PersonalChecked"
            (change)="selectNotes($event)">Personal</mat-radio-button>
          <mat-radio-button color="primary" value="1" [checked]="GlobalChecked" (change)="selectNotes($event)">Office
            (global for organization)</mat-radio-button>
        </mat-radio-group> -->

      <mat-form-field class="mt-10 noteh" appearance="fill">
        <mat-label>Add Note</mat-label>
        <textarea matInput placeholder="Write Note..." formControlName="notes"
          (ngModelChange)="onAddNoteCharCheck($event)" [maxlength]="maxChars"></textarea>
      </mat-form-field>
      <div class="charColor">
        <div class="colGroup">
          <ng-container>
            <ng-container *ngFor="let color of col; let i as index">
              <label class="colm" [ngStyle]="{'background-color': color.colname }">
                <input type="radio" id="{{i}}" type="radio" value="{{color.colname}}" name="noteColor"
                  formControlName="color">
                <span class="checkmark"></span>
              </label>
            </ng-container>
          </ng-container>

        </div>
        <label class="nopadding clrlbl"> Characters Remaining: {{maxChars - addnotes}}</label>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="savebuttonshow" [disabled]="!addNotesForm.valid"
      (click)="AddNotes(addNotesForm.value)">Save
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>
</ng-template>


<ng-template #AddSignature>
  <h2 mat-dialog-title class="signTitle">

    <ng-container *ngIf="hasSignature">My Signature</ng-container>
    <ng-container *ngIf="!hasSignature">Adopt your signature</ng-container>

    <ng-container *ngIf="hasSignature">
      <button mat-flat-button class="addNewSignButton" color="primary" (click)="addNewSignature()"
        [disabled]="fiveSignaturesLimitReached">
        <mat-icon>add</mat-icon> Add signature
      </button>
    </ng-container>
    <ng-container *ngIf="!hasSignature">
      <button mat-stroked-button class="addNewSignButton" color="primary" (click)="addNewSignature()"
        [disabled]="fiveSignaturesLimitReached">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
    </ng-container>

    <button mat-icon-button (click)="closeSignature()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <ng-container>

    <mat-dialog-content class="mat-typography">
      <div class="tabConainer">

        <ng-container *ngIf="!hasSignature">
          <!-- new signature add options -->
          <div class="signatureOptions">

            <div class="drawSignature" [ngClass]="{'active': signOpt == 'draw'}" (click)="signatureType('draw')">
              <div class="icon">
                <img src="./../../../assets/images/signature.png" alt="">
              </div>
              <div class="info">
                <h3>Draw your signature</h3>
                <p>Draw your signature here using your mouse or trackpad.</p>
              </div>
            </div>


            <div class="drawSignature" [ngClass]="{'active': signOpt == 'uploads'}" (click)="signatureType('upload')">
              <div class="icon">
                <img src="./../../../assets/images/uploadIcon.png" alt="">
              </div>
              <div class="info">
                <h3>Upload your signature</h3>
                <p>Upload an image on your handwritten signature here.</p>
              </div>
            </div>

            <div class="drawSignature" [ngClass]="{'active': signOpt == 'type'}" (click)="signatureType('type')">
              <div class="icon">
                <img src="./../../../assets/images/typeIn.png" alt="">
              </div>
              <div class="info">
                <h3>Type in your signature</h3>
                <p>Add your name and select any font.</p>
              </div>
            </div>

          </div>
          <!-- new signature add options -->

          <!-- new signature Preview & Holder -->
          <div class="previewHolder">
            <h3 class="preview_text">PREVIEW</h3>
            <div class="previewContainer">
              <ng-container *ngIf="signOpt == 'upload'">
                <div class="uploadholderSignature">
                  <img src="./../../../assets/images/uploadIcon.png" alt="" width="60">
                  <p *ngIf="filenameForSign == '' ">Upload your signature</p>
                  <span *ngIf="filenameForSign == '' ">Upload an png image on your handwritten signature here</span>
                  <p>{{filenameForSign}}</p>
                  <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
                    placeholder="Add file">
                </div>
              </ng-container>

              <ng-container *ngIf="signOpt == 'draw'">
                <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                  (onEndEvent)="drawComplete()"></signature-pad>
              </ng-container>

              <ng-container *ngIf="signOpt == 'type'">
                <div class="divideCol">
                  <div class="left blk">
                    <mat-form-field>
                      <mat-label>Enter Name</mat-label>
                      <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName"
                        (ngModelChange)="signOrInitialTextChanges($event)">
                    </mat-form-field>
                  </div>
                  <div class="right blk">
                    <mat-form-field appearance="fill">
                      <mat-label>Select font family</mat-label>
                      <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                        <mat-option *ngFor="let fam of family; index as i"
                          value="{{fam.font}}">{{fam.font}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="allSign">
                  <div class="signlook" [ngStyle]="{'font-family': signInitialFontFamily }">
                    {{signName}}
                  </div>
                  <style>
                    @import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap';
                  </style>
                </div>
              </ng-container>
            </div>
          </div>
          <!-- new signature Preview & Holder -->
        </ng-container>



        <div *ngIf="hasSignature" class="signatureListHolder">

          <span class="limitReached" *ngIf="fiveSignaturesLimitReached">You can add upto 5 signatures only. Please
            delete a signature if you want to add new.</span>

          <div *ngFor="let img of getAllSignatures" class="signatureList">

            <div class="uploadedData"
            (click)="selectedSignature(img)"
              [ngClass]="{ 'active': signatureID === img.signatureID || img.isDefault == true }">

              <mat-icon class="unselect">radio_button_unchecked</mat-icon>
              <mat-icon class="select">check_circle</mat-icon>

              <div class="sig-cell">
                <div class="sig-chrome">
                  <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                  <div class="sig-container">

                    <ng-container *ngIf="img.signature.type=='Draw'">
                      <div class="signature">
                        <img [src]="img.signature.signatureBase64" />
                      </div>
                    </ng-container>

                    <ng-container *ngIf="img.signature.type=='Upload'">
                      <div *ngFor="let img1 of img.signature.ImageData" class="signature">
                        <img [src]="img1.Imageurl" />
                      </div>
                    </ng-container>


                    <ng-container *ngIf="img.signature.type=='Type In'">
                      <div class="signature">
                        <h3 [ngStyle]="{'font-family': img.signature.signInitialFontFamily}">
                          {{img.signature.signatureText}}</h3>
                      </div>
                    </ng-container>

                  </div>
                  <div class="sig-chrome-title-bottom ng-binding">{{this.portalEmail}}</div>
                </div>
              </div>

              <button mat-icon-button class="closeIcon"
                (click)="deleteSignature(img)"><mat-icon>close</mat-icon></button>
            </div>

          </div>
        </div>


      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="closeSignature()">Cancel</button>
      <span>
        <button *ngIf="signOpt == 'draw' && !hasSignature" mat-stroked-button color="primary"
          (click)="clearSignature()">Clear</button>

        <button *ngIf="hasSignature" mat-flat-button (click)="addDefaultSignature()" color="primary">Adopt &
          Sign</button>

        <button *ngIf="!hasSignature" mat-flat-button (click)="addSignature()" color="primary"
          [disabled]="!SignButtonEnable">Adopt & Sign</button>
      </span>
    </mat-dialog-actions>
  </ng-container>

</ng-template>


<ng-template #showBroadcastDialog>
  <h2 mat-dialog-title>
    Broadcast Message 
    <button mat-icon-button (click)="closeBroadcast()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>


    <div class="broadHolder" >
      <div class="broadImg">
        <img src="{{ BroadcastofficeLogo }}" width="50" alt="">
      </div>


      <div class="text" >
        <h4> {{Broadcasttitle}} <i>{{BroadcastDate+'Z' | date:'MM/dd/yyyy'}} </i></h4>
        <div class="innerHTML" bind-innerHTML="BroadcastMessage"></div>
        
        <!-- <p [innerHTML]="BroadcastMessage"></p> -->
        <div class="nDetail">
          {{BroadcastorganizationName}} <mat-icon>chevron_right</mat-icon> {{BroadcastofficeName}}
        </div>

      </div>


    </div>

  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeBroadcast()"></button>
    <button mat-button color="basic" (click)="closeBroadcast()">Cancel</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #docViewer>
  <app-document-viewer
  (getCloseDocumentViewer)="getCloseDocumentViewer($event)"
  [ngClass]="{ open: documentViewer }"
  [documentpath]="documentPath"
  [documentType]="fileType"
  [documentName]="documentname">
  </app-document-viewer>
  </ng-template>

  <app-chatpanel  *ngIf="showChat"
  (hideChat)="getChatclose($event)"
  (openChatWindow)=getopenChatWindow($event)
  [ngClass]="{'open': showChat, 'showChat': showChatWindow }">
</app-chatpanel>